"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalAccountServiceGetStartggEntryStatusResponse = exports.LegacyPortalAccountServiceGetStartggEntryStatusRequest = exports.LegacyPortalAccountServiceExchangeStartggCodeResponse = exports.LegacyPortalAccountServiceExchangeStartggCodeRequest = exports.LegacyPortalAccountServiceLinkWithFanyIdResponse = exports.LegacyPortalAccountServiceLinkWithFanyIdRequest = exports.LegacyPortalAccountServiceSignInWithFanyIdResponse = exports.LegacyPortalAccountServiceSignInWithFanyIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * FANY IDサインイン開始
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdRequest
 */
class LegacyPortalAccountServiceSignInWithFanyIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * サインイン処理開始前にいたURL
         *
         * @generated from field: string from = 1;
         */
        this.from = "";
        /**
         * サインイン処理を開始したportalのorigin
         *
         * @generated from field: string origin = 2;
         */
        this.origin = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceSignInWithFanyIdRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceSignInWithFanyIdRequest = LegacyPortalAccountServiceSignInWithFanyIdRequest;
LegacyPortalAccountServiceSignInWithFanyIdRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceSignInWithFanyIdRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdRequest";
LegacyPortalAccountServiceSignInWithFanyIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdResponse
 */
class LegacyPortalAccountServiceSignInWithFanyIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FANY IDサードパーティログインURL
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * `param`パラメータの値 (サードパーティログインに必要な値を暗号化した文字列)
         *
         * @generated from field: string param = 2;
         */
        this.param = "";
        /**
         * `site`パラメータの値 (サイトID)
         *
         * @generated from field: string site_id = 3;
         */
        this.siteId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceSignInWithFanyIdResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceSignInWithFanyIdResponse = LegacyPortalAccountServiceSignInWithFanyIdResponse;
LegacyPortalAccountServiceSignInWithFanyIdResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceSignInWithFanyIdResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdResponse";
LegacyPortalAccountServiceSignInWithFanyIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * FANY ID連携開始
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdRequest
 */
class LegacyPortalAccountServiceLinkWithFanyIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 連携処理を開始したportalのorigin
         *
         * @generated from field: string origin = 1;
         */
        this.origin = "";
        /**
         * 表示名
         *
         * @generated from field: string display_name = 2;
         */
        this.displayName = "";
        /**
         * email
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceLinkWithFanyIdRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceLinkWithFanyIdRequest = LegacyPortalAccountServiceLinkWithFanyIdRequest;
LegacyPortalAccountServiceLinkWithFanyIdRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceLinkWithFanyIdRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdRequest";
LegacyPortalAccountServiceLinkWithFanyIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdResponse
 */
class LegacyPortalAccountServiceLinkWithFanyIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FANY IDサードパーティログインURL
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * `param`パラメータの値 (サードパーティログインに必要な値を暗号化した文字列)
         *
         * @generated from field: string param = 2;
         */
        this.param = "";
        /**
         * `site`パラメータの値 (サイトID)
         *
         * @generated from field: string site_id = 3;
         */
        this.siteId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceLinkWithFanyIdResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceLinkWithFanyIdResponse = LegacyPortalAccountServiceLinkWithFanyIdResponse;
LegacyPortalAccountServiceLinkWithFanyIdResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceLinkWithFanyIdResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdResponse";
LegacyPortalAccountServiceLinkWithFanyIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * start.gg authorization code の交換
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceExchangeStartggCodeRequest
 */
class LegacyPortalAccountServiceExchangeStartggCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * authorize から返ってきた authorization code
         *
         * @generated from field: string code = 1;
         */
        this.code = "";
        /**
         * authorize 時と完全一致させる redirect_uri
         *
         * @generated from field: string redirect_uri = 2;
         */
        this.redirectUri = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceExchangeStartggCodeRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceExchangeStartggCodeRequest = LegacyPortalAccountServiceExchangeStartggCodeRequest;
LegacyPortalAccountServiceExchangeStartggCodeRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceExchangeStartggCodeRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceExchangeStartggCodeRequest";
LegacyPortalAccountServiceExchangeStartggCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "redirect_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceExchangeStartggCodeResponse
 */
class LegacyPortalAccountServiceExchangeStartggCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * start.gg の User.id
         *
         * @generated from field: string startgg_user_id = 1;
         */
        this.startggUserId = "";
        /**
         * start.gg の gamerTag（無ければ slug）
         *
         * @generated from field: string startgg_username = 2;
         */
        this.startggUsername = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceExchangeStartggCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceExchangeStartggCodeResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceExchangeStartggCodeResponse = LegacyPortalAccountServiceExchangeStartggCodeResponse;
LegacyPortalAccountServiceExchangeStartggCodeResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceExchangeStartggCodeResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceExchangeStartggCodeResponse";
LegacyPortalAccountServiceExchangeStartggCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "startgg_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "startgg_username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * start.gg entry 状況の取得
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceGetStartggEntryStatusRequest
 */
class LegacyPortalAccountServiceGetStartggEntryStatusRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 連携済み start.gg User.id
         *
         * @generated from field: string startgg_user_id = 1;
         */
        this.startggUserId = "";
        /**
         * 確認対象の start.gg Event.id
         *
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceGetStartggEntryStatusRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceGetStartggEntryStatusRequest = LegacyPortalAccountServiceGetStartggEntryStatusRequest;
LegacyPortalAccountServiceGetStartggEntryStatusRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceGetStartggEntryStatusRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceGetStartggEntryStatusRequest";
LegacyPortalAccountServiceGetStartggEntryStatusRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "startgg_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceGetStartggEntryStatusResponse
 */
class LegacyPortalAccountServiceGetStartggEntryStatusResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 対象イベントの entrants に載っているか
         *
         * @generated from field: bool entered = 1;
         */
        this.entered = false;
        /**
         * 一致した participant の gamerTag（未entryなら空）
         *
         * @generated from field: string gamer_tag = 2;
         */
        this.gamerTag = "";
        /**
         * phaseGroup.displayIdentifier（ブラケット未確定なら空）
         *
         * @generated from field: string pool = 3;
         */
        this.pool = "";
        /**
         * seedNum（未確定なら 0）
         *
         * @generated from field: int32 seed_num = 4;
         */
        this.seedNum = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceGetStartggEntryStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceGetStartggEntryStatusResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceGetStartggEntryStatusResponse = LegacyPortalAccountServiceGetStartggEntryStatusResponse;
LegacyPortalAccountServiceGetStartggEntryStatusResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceGetStartggEntryStatusResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceGetStartggEntryStatusResponse";
LegacyPortalAccountServiceGetStartggEntryStatusResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "entered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "gamer_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pool", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seed_num", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map